// Names and original artwork supplied by AFTH on 5 October 2026.
const shirt = (name, theme, slug, views = ['front', 'back']) => ({
  name, theme, images: views.map(view => `/yoty/shirt-${slug}-${view}.png`),
});
export const yotyDesigns = {
  Shirt: [
    shirt('Bearcade', 'Main Character Moment', 'bearcade'),
    shirt('Big wins', 'Main Character Moment', 'big-wins'),
    shirt('Pixel warrior', 'Main Character Moment', 'pixel-warrior', ['view-1', 'back']),
    shirt('RPG', 'Main Character Moment', 'rpg'),
    shirt('Cosmic hour', 'Starbound', 'cosmic-hour'),
    shirt('intergalactic friends', 'Starbound', 'intergalactic-friends'),
    shirt('Launch', 'Starbound', 'launch'),
  ],
  Keychain: [
    { name: 'Cat with fish', images: ['/yoty/keychain-cat-with-fish.png'] },
    { name: 'Rabbit', images: ['/yoty/keychain-rabbit.png'] },
  ],
  Sticker: [
    { name: 'Mouse with cheese', images: ['/yoty/sticker-mouse-with-cheese.png'] },
    { name: 'Shopping Fox', images: ['/yoty/sticker-shopping-fox.png'] },
  ],
};
export const findYotyDesign = (type, name) => yotyDesigns[type]?.find(design => design.name === name);
export const yotyDesignLabel = design => design.theme ? `${design.theme} — ${design.name}` : design.name;
